import { useEffect } from "react";
import { getMultiUserPlans, getPlans } from "../LandingPage";

export function useCheckoutPlan() {
    const urlParams = new URLSearchParams(window.location.search);
    const planId = urlParams.get('plan');
    const isMultiUser = urlParams.get('isMultiUser') === 'true';
    const plans = getPlans();
    const familyPlan = getMultiUserPlans();
    const plan = isMultiUser ? familyPlan.find((p) => p.id === planId) : plans.find((p) => p.id === planId);
  
    useEffect(() => {
      if (!plan || plan.isOneTime) {
        window.location.href = "/results";
      }
    }, [plan]);

    return plan;
}